import ClientLayerBlueprint from "components/blueprints/ClientLayerBlueprint";
import React from "react";

function ClientSettingsPage() {
  return <div>ClientSettingsPage</div>;
}

export default ClientLayerBlueprint(ClientSettingsPage);
